import Blockly from '@/assets/blockly/renderers/index.js'
import GTheme from '@/assets/blockly/theme/gtheme.js'
const createBlock = {
  state: () => ({
    newBlocksType: {
      // blocksContent: "",
      // blocksId: "530ff139-3179-0153-4e47-acfa011c23bb",
      // blocksLevel: 3,
      // blocksName: "新建积木",
      // blocksOrder: 2,
      // isEnabled: true,
      // parentId: "3e5cf139-9950-dabd-3386-a37382fcdb1c",
      // showType: 1,
      // newBlockCodeStr: ""
    },
    newBlockCodeStr: '',
    newBlocks: [
      {
        blocksContent:
          '<button text="创建新积木" callbackKey="openCreateBlockFun" web-class="new-block-btn label-text"></button>',
        blocksId: 'acdebcff-fae9-11e9-8652-00505684dca8',
        blocksLevel: 4, //levels水平不能为5
        blocksName: 'gta_ai_new_block_btn',
        parentId: '3e5cf139-9950-dabd-3386-a37382fcdb1c',
        // parentId: "530ff139-3179-0153-4e47-acfa011c23bb",
        showType: 2,
      },
      {
        blocksContent: '<label text="" web-class="myLabelStyle4" ></label>',
        blocksId: 'acdebcff-fae9-11e9-8652-00505684dca9',
        blocksLevel: 4, //levels水平不能为5
        blocksName: 'gta_ai_new_block_line',
        parentId: '',
        // parentId: "530ff139-3179-0153-4e47-acfa011c23bb",
        showType: 2,
      },
    ],
    newBlockObj: {}, //存储建立积木的名称和参数变量;
    newBlockText: '', //新建积木的block文本 //在确定建积木时使用
    newBlockPythonText: '', //新建积木的python文本 //在确定建积木时使用
    paramNameStr: '', //存储自建积木的参数;
    newBlockParamsList: [], //存储自建积木的参数;
  }),
  getters: {
    newBlocks: (state) => {
      return state.newBlocks
    },
    newBlocksType: (state) => {
      return state.newBlocksType
    },
  },
  mutations: {
    createNewBlock(state, val) {
      console.log(state, val)
    },
    //创建积木步骤1：创建一个用于识别匹配后面代码功能的积木;
    getCreateNewCode(state, val) {
      const { blockName, paramsList } = val
      state.newBlockObj = val
      let paramText_1 = '' //参数变量的文本1 ，用作定义积木的参数变量
      let paramText_2 = '' //参数变量的文本2 ，用作确定生成积木的参数变量
      let pythonText = '' //python脚本中变量的文本
      let paramNameStr = '' //pytho变量参数的处理
      state.newBlockParamsList = paramsList
      paramsList.forEach((ele, index) => {
        const paramName = ele.paramText
        const paramLabel = ele.paramLabel //标签名称
        // const paramName = ele.paramText_2 + JSON.stringify(index);
        paramText_1 += `.appendField("${paramName}")`
        paramText_2 += `.appendField("${paramName}").appendField(new Blockly.FieldTextInput(""),"${paramName}")`
        if (paramLabel) {
          paramText_1 += `.appendField("${paramLabel}")`
          paramText_2 += `.appendField("${paramLabel}")`
        }

        //python文本处理
        pythonText += `var ${paramName} = block.getFieldValue("${paramName}");\n`
        //pytho变量参数;
        paramNameStr += `${paramName}=${ele.paramType},`
      })
      paramText_1 += `;\n`
      paramText_2 += `;\n`
      // blockly脚本的处理
      const newBlockText =
        `Blockly.Blocks["DEF_BLOCK_${blockName}"]={
        init: function() {
          this.appendDummyInput()` +
        `.appendField("定义积木：")
        .appendField(new Blockly.FieldLabelSerializable("${val.blockName}"), "BlockName")
        
        ` +
        paramText_1 +
        ` this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setColour("#f52276");
          this.setTooltip("");
          this.setHelpUrl('');
        }
      };`

      const newBlockText_2 =
        `Blockly.Blocks["DEF_BLOCK_${blockName}"]={
        init: function() {
          this.appendDummyInput()` +
        `.appendField(new Blockly.FieldLabelSerializable("${val.blockName}"), "BlockName")` +
        paramText_2 +
        ` this.setPreviousStatement(true, null);
          this.setNextStatement(true, null);
          this.setStyle("custom_blocks");
          this.setTooltip("");
          this.setHelpUrl( Blockly.Msg['DEF_BLOCK_${blockName}']);
          }, ` +
        `customContextMenu:function(options) {
            var option= {
              enabled:true,
              text:"删除",
              callback:function() {
                deleteDefBlocks("DEF_BLOCK_${blockName}")
              }.bind(this)
              };
              var option2= {
                  enabled:true,
                  text:"重命名",
                  callback:function() {
                    renameDefBlocks("DEF_BLOCK_${blockName}")}.bind(this)
                };
              options.push(option); 
              options.push(option2); 
        }
      };`

      // 去掉最后一个逗号
      paramNameStr = paramNameStr.substring(0, paramNameStr.length - 1)

      state.paramNameStr = paramNameStr //存储自建积木的参数;
      //python脚本的拼接
      // var BlockName = block.getFieldValue("BlockName");\n
      const newBlockPythonText = `
      Blockly.Python["DEF_BLOCK_${blockName}"]=function(block) {
        ${pythonText} 
        var code = "CREATEBLOCK(${paramNameStr})"+"\\n";
        return code;
      };`
      const res = newBlockText + newBlockPythonText
      state.newBlockCodeStr = res
      state.newBlockText = newBlockText //用于步骤1建一个匹配的积木
      state.newBlockText_2 = newBlockText_2 //用于最后步骤，确定生成一个积木脚本时;
      state.newBlockPythonText = newBlockPythonText
      console.log(res)
      return res
    },
    //获取新建积木的pythod脚本;
  }, //mutations end
}

export default createBlock
